module.exports = __webpack_public_path__ + "img/bg-no-money.1a863607.png";